import {DocumentNode, gql} from '@apollo/client';
import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {TeamMembersTeam} from 'orgs/__generated/TeamMembersTeam';
import {navigateToUserPage} from 'orgs/UserPage';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import MembersTable from './MembersTable';
import * as OrganizationConstants from './OrganizationConstants';

export const TEAM_MEMBERS_TEAM_FRAGMENT: DocumentNode = gql`
  fragment TeamMembersTeam on TeamNode {
    id
    permissions {
      canManageRoles
    }
  }
`;
interface TeamMembersTabProps {
  team: TeamMembersTeam;
  teamMembers?: Array<OrganizationConstants.Member>;
  isCurrentUserMember: boolean;
  userIdToMemberInfo: {[userId: string]: OrganizationConstants.MemberInfo} | null;
}

export default function TeamMembersTab({
  team,
  teamMembers,
  isCurrentUserMember,
  userIdToMemberInfo,
}: TeamMembersTabProps): JSX.Element {
  if (!teamMembers || !userIdToMemberInfo) {
    return <CenteredHorizontalThrobber />;
  }

  if (teamMembers.length === 0) {
    return <div>No members yet.</div>;
  }

  const canManageRoles = team.permissions.canManageRoles ?? false;

  return (
    <MembersTable
      groupId={team.id}
      groupType={ModelTypeConstants.TEAM}
      canManageRoles={canManageRoles}
      members={teamMembers}
      shouldShowMemberInfo={isCurrentUserMember || canManageRoles}
      userIdToMemberInfo={userIdToMemberInfo}
      onRowClick={function (row: {id: string}) {
        navigateToUserPage(row.id);
      }}
    />
  );
}
